module.exports = __webpack_public_path__ + "static/media/iPhone-X.d61e7849.png";